import React from 'react'
import { Dropdown, Button } from 'react-bootstrap'
import { Notify } from '../../assets/svg'
import Profile from '../../assets/images/default-placeholder.png'
import './index.css'
import { useNavigate } from 'react-router-dom'
import { useAppSelector } from '../../redux/hook'
import NotificationModal from '../NotificationModal'
import SearchComponent from './components/viewUsersModal/index'
import {
    getAllNotification,
    markReadNotificatiopn,
} from '../../features/notification/api'
import { useAppDispatch } from '../../redux/hook'
import { HIDE_LOADER, SHOW_LOADER } from '../../redux/slices/LoaderSlice'

const Navbar = () => {
    const dispatch = useAppDispatch()
    const [show, setShow] = React.useState(false)
    const [target, setTarget] = React.useState(null)
    const [notifications, setNotifications] = React.useState<any[]>([])
    const [unRead, setUnread] = React.useState(0)
    const navigate = useNavigate()
    const { firstName, role, lastName, image } = useAppSelector(
        (state) => state.persistedReducers.user
    )

    const handleClickNotiIcon = (event: any) => {
        loadNotificationInHeader()
        setShow(!show)
        setTarget(event.target)
    }

    const loadNotificationInHeader = async () => {
        try {
            const res = await getAllNotification({
                currentPage: 1,
                recordsPerPage: 10,
                unReadNotifications: true,
            })
            res?.data?.data?.sort(
                (a: { createdOn: string }, b: { createdOn: string }) =>
                    new Date(b.createdOn).getTime() -
                    new Date(a.createdOn).getTime()
            )
            const unRead = res?.data?.data?.filter((item: any) => !item.isSeen)
            setUnread(unRead?.length)
            setNotifications(res?.data?.data)
        } catch (e) {
            console.error('Error', e)
        }
    }
    console.log(unRead)
    const readNotification = async (id: string | null) => {
        const payload = {
            notificationId: id,
            isAllMarkAsRead: id ? false : true,
        }
        try {
            dispatch(SHOW_LOADER())

            const res = await markReadNotificatiopn(payload)
            if (res) {
                return setNotifications((prev) =>
                    prev.map((item) => {
                        if (item.id === id) {
                            return {
                                ...item,
                                isSeen: true,
                            }
                        }
                        return item
                    })
                )
            }
        } catch (e) {
            console.error('Error', e)
        } finally {
            dispatch(HIDE_LOADER())
        }
    }

    return (
        <>
            <nav className="d-flex justify-content-between align-items-center">
                <div className="col-6">
                    {role !== 'Teacher' && <SearchComponent />}
                </div>
                <ul className="navbar-nav navbar-nav-icons flex-row align-items-center">
                    <li className="nav-item me-3">
                        <Button onClick={handleClickNotiIcon} variant="link">
                            <img src={Notify}></img>
                        </Button>
                        {show && (
                            <NotificationModal
                                target={target}
                                setShow={setShow}
                                notifications={notifications}
                                readNotification={readNotification}
                            />
                        )}
                    </li>
                    <li className="nav-item nav-dropdown">
                        <Dropdown className="nav-dropdown">
                            <Dropdown.Toggle variant="" id="dropdown-basic">
                                <img
                                    src={image ? image : Profile}
                                    className="profile-picture"
                                    alt="Profile"
                                />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item>
                                    {firstName} {lastName}
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={() =>
                                        navigate('/profile/changepassword')
                                    }
                                >
                                    Change Password
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </li>
                </ul>
            </nav>
        </>
    )
}

export default Navbar
